var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#061E2A",
  d: "m5.386 9.5-.943-.9 2.443-2.366H1.5V4.78h5.386L4.429 2.413 5.37 1.5l4.129 4z"
})));
export { SvgArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTEgMTEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aAogICAgICAgIGQ9Ik01LjM4NTcxIDkuNUw0LjQ0Mjg2IDguNjAwMzVMNi44ODU3MSA2LjIzMzU2SDEuNVY0Ljc4MDI4SDYuODg1NzFMNC40Mjg1NyAyLjQxMzQ5TDUuMzcxNDMgMS41TDkuNSA1LjVMNS4zODU3MSA5LjVaIgogICAgICAgIGZpbGw9IiMwNjFFMkEiIC8+Cjwvc3ZnPg==";